import _ from 'lodash';
import { RM3_DEFAULT_FILTERS, RM3_FILTER, RM3_SORT } from 'arbitrip-common/client/utils/HotelDealsRm3';

export const RM3_ACTION = Object.freeze({
    TOGGLE_TOP_PICK: 'toggleTopPick',
    TOGGLE_FREE_CANCELLATION: 'toggleFreeCancellation',
    SELECT_EXTRAS: 'selectExtras',
    SELECT_BED: 'selectBed',
    TOGGLE_IN_POLICY: 'toggleInPolicy',
    TOGGLE_PAY_AT_HOTEL: 'togglePayAtHotel',
    SET_SORT: 'setSort',
    RESET_FILTERS: 'resetFilters',
    RESET: 'reset',
});

function defaultFilters() {
    return { ...RM3_DEFAULT_FILTERS, [RM3_FILTER.TOP_PICKS]: [] };
}

export function initialRm3FiltersState() {
    return {
        filters: defaultFilters(),
        sort: RM3_SORT.PRICE,
        freeCancellationManuallySet: false,
    };
}

export function isAnyRm3FilterOn(filters) {
    return !_.isEqual(filters, defaultFilters());
}

function withFilter(state, key, value) {
    return { ...state, filters: { ...state.filters, [key]: value } };
}

/**
 * Filter + sort state of the RM3 section (spec §3.5). The sort's auto-enable rule mirrors
 * `HotelPage.handleSortByChange`: choosing the cancellation-date sort turns Free cancellation on;
 * choosing price turns it off again only when the user did not set it themselves
 * (`freeCancellationManuallySet`, which takes the chip's new value as `onFreeCancellationToggle` does today).
 */
export default function rm3FiltersReducer(state, action) {
    switch (action.type) {
        case RM3_ACTION.TOGGLE_TOP_PICK: {
            const selected = state.filters[RM3_FILTER.TOP_PICKS];
            const next = selected.includes(action.value)
                ? selected.filter((kind) => kind !== action.value)
                : [...selected, action.value];
            return withFilter(state, RM3_FILTER.TOP_PICKS, next);
        }
        case RM3_ACTION.TOGGLE_FREE_CANCELLATION: {
            const next = !state.filters[RM3_FILTER.FREE_CANCELLATION];
            return { ...withFilter(state, RM3_FILTER.FREE_CANCELLATION, next), freeCancellationManuallySet: next };
        }
        case RM3_ACTION.SELECT_EXTRAS:
            return withFilter(
                state,
                RM3_FILTER.EXTRAS,
                state.filters[RM3_FILTER.EXTRAS] === action.value ? null : action.value,
            );
        case RM3_ACTION.SELECT_BED:
            return withFilter(
                state,
                RM3_FILTER.BED,
                state.filters[RM3_FILTER.BED] === action.value ? null : action.value,
            );
        case RM3_ACTION.TOGGLE_IN_POLICY:
            return withFilter(state, RM3_FILTER.IN_POLICY, !state.filters[RM3_FILTER.IN_POLICY]);
        case RM3_ACTION.TOGGLE_PAY_AT_HOTEL:
            return withFilter(state, RM3_FILTER.PAY_AT_HOTEL, !state.filters[RM3_FILTER.PAY_AT_HOTEL]);
        case RM3_ACTION.SET_SORT: {
            const freeCancellation = state.filters[RM3_FILTER.FREE_CANCELLATION];
            let next = { ...state, sort: action.value };
            if (action.value === RM3_SORT.CANCELLATION_DATE && !freeCancellation) {
                next = withFilter(next, RM3_FILTER.FREE_CANCELLATION, true);
            } else if (action.value === RM3_SORT.PRICE && freeCancellation && !state.freeCancellationManuallySet) {
                next = withFilter(next, RM3_FILTER.FREE_CANCELLATION, false);
            }
            return next;
        }
        case RM3_ACTION.RESET_FILTERS:
            return { ...state, filters: defaultFilters(), freeCancellationManuallySet: false };
        case RM3_ACTION.RESET:
            return initialRm3FiltersState();
        default:
            return state;
    }
}
